import type { Entity, Investigation } from '@onefootprint/request-types/dashboard';

export const GENERATED_SUMMARY_OPTION_ID = 'generated-summary';
export type ArtifactSelectorOptionId = typeof GENERATED_SUMMARY_OPTION_ID | (string & {}); // `string & {}` keeps the literal in IntelliSense

export type HeaderProps = {
  investigation: Investigation;
  /** Optional: investigations may have no entity (e.g. a Percy orchestrator parent). */
  entity?: Entity;
  subInvestigations?: Investigation[];
  hasMoreSubInvestigations?: boolean;
  subInvestigationsParentId?: string;
  /** The full parent investigation, when this is a child and its row has loaded. */
  parentInvestigation?: Investigation;
  isSidebarOpen?: boolean;
  onToggleSidebar?: () => void;
  sourceCount?: number;
  citedSourceCount?: number;
  onOpenSources?: () => void;
};
